(function () {
  'use strict';
  if (window.StikwoodJourney || !window.fetch || !window.crypto) return;
  var endpoint = 'https://stikwood-capi-733286122942.us-central1.run.app/journey/';
  var identityKey = 'sw_journey_identity';
  var sessionKey = 'sw_journey_session';
  var revokeKey = 'sw_journey_revoke';
  var maxAge = 395 * 86400;
  var sessionAge = 1800000;
  var originalFetch = window.fetch;
  var generation = 0;
  var eventQueue = Promise.resolve();
  var cartQueue = Promise.resolve();
  var pendingCount = 0;
  var lastMirror = '';
  var booted = false;
  var lastAllowed = false;
  var denialSettling = false;
  var revoking = null;
  var privacyLoading = false;
  var activeRequests = new Set();
  var config = document.getElementById('sw-journey-recorder');
  var page = config ? config.dataset : {};
  var events = new Set(['page_view', 'product_view', 'collection_view', 'search', 'cart_view',
    'add_to_cart', 'cart_updated', 'checkout_clicked', 'calculator_used', 'video_engaged', 'sample_cta_clicked']);

  function cookie(name) {
    try {
      var part = document.cookie.split(';').find(function (p) { return p.trim().startsWith(name + '='); });
      return part ? decodeURIComponent(part.trim().slice(name.length + 1)) : '';
    } catch (_) { return ''; }
  }
  function read(name) { try { return JSON.parse(cookie(name)); } catch (_) { return null; } }
  function write(name, value, age) {
    try { document.cookie = name + '=' + encodeURIComponent(JSON.stringify(value)) +
      '; Path=/; Max-Age=' + Math.floor(age) + '; SameSite=Lax; Secure'; } catch (_) {}
  }
  function erase(name) { write(name, '', 0); }
  function uuid() {
    if (window.crypto.randomUUID) return window.crypto.randomUUID();
    var bytes = window.crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128;
    var hex = Array.from(bytes, function (b) { return b.toString(16).padStart(2, '0'); }).join('');
    return hex.slice(0, 8) + '-' + hex.slice(8, 12) + '-' + hex.slice(12, 16) + '-' + hex.slice(16, 20) + '-' + hex.slice(20);
  }
  function consent() {
    var api = window.Shopify && window.Shopify.customerPrivacy;
    function check(name) { try { return !!api && typeof api[name] === 'function' && api[name]() === true; } catch (_) { return false; } }
    var known = false;
    try { var status = api && typeof api.analyticsProcessingAllowed === 'function' ? api.analyticsProcessingAllowed() : null; known = status === true || status === false; } catch (_) {}
    return { analytics_allowed: check('analyticsProcessingAllowed'), marketing_allowed: check('marketingAllowed'), sale_of_data_allowed: check('saleOfDataAllowed'), analytics_known: known };
  }
  function permitted(g) { return generation === g && consent().analytics_allowed; }
  function expiry(value) { return typeof value === 'number' ? value * 1000 : Date.parse(value); }
  function validIdentity(value) {
    return value && typeof value.visitor_id === 'string' && typeof value.visitor_token === 'string' &&
      value.visitor_token.length < 2500 && expiry(value.expires_at) > Date.now();
  }
  function session() {
    var value = read(sessionKey);
    if (!value || !/^[0-9a-f-]{36}$/i.test(value.id) || !Number.isFinite(value.last_at) ||
        value.last_at > Date.now() || Date.now() - value.last_at >= sessionAge) value = { id: uuid() };
    value.last_at = Date.now();
    write(sessionKey, value, sessionAge / 1000);
    return value.id;
  }
  function request(path, body, cancellable) {
    var controller = new AbortController();
    if (cancellable) activeRequests.add(controller);
    var timer = setTimeout(function () { controller.abort(); }, 10000);
    return originalFetch.call(window, endpoint + path, {
      method: 'POST', mode: 'cors', credentials: 'omit', cache: 'no-store',
      headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), signal: controller.signal,
      keepalive: true
    }).finally(function () { clearTimeout(timer); activeRequests.delete(controller); });
  }
  function rememberRevocation(value) {
    if (!value || !value.visitor_token) return;
    var pending = read(revokeKey) || [];
    if (!Array.isArray(pending)) pending = [];
    if (!pending.some(function (p) { return p.visitor_token === value.visitor_token; })) {
      pending.push({ visitor_token: value.visitor_token });
      write(revokeKey, pending, maxAge);
    }
  }
  function revokePending() {
    var pixelWithdrawal = read('sw_journey_pixel_withdraw');
    if (pixelWithdrawal && pixelWithdrawal.visitor_token) {
      rememberRevocation(pixelWithdrawal);
      erase('sw_journey_pixel_withdraw');
    }
    if (revoking) return revoking;
    revoking = (async function () {
      var pending = read(revokeKey) || [];
      if (!Array.isArray(pending)) return false;
      for (var item of pending) {
        try {
          var response = await request('withdraw', item, false);
          if (!response.ok) return false;
          var remaining = (read(revokeKey) || []).filter(function (p) { return p.visitor_token !== item.visitor_token; });
          if (remaining.length) write(revokeKey, remaining, maxAge); else erase(revokeKey);
        } catch (_) { return false; }
      }
      return !(read(revokeKey) || []).length;
    })().finally(function () { revoking = null; });
    return revoking;
  }
  function mirror(value, sid, g) {
    cartQueue = cartQueue.catch(function () {}).then(async function () {
      var allowed = value && permitted(g) && validIdentity(read(identityKey)) &&
        read(identityKey).visitor_token === value.visitor_token;
      var attributes = { _sw_journey_token: allowed ? value.visitor_token : '',
        _sw_journey_session: allowed ? sid : '', _sw_journey_analytics: allowed ? 'true' : '' };
      var key = JSON.stringify(attributes);
      if (key === lastMirror) return;
      var controller = new AbortController();
      var timer = setTimeout(function () { controller.abort(); }, 10000);
      try {
        var response = await originalFetch.call(window, '/cart/update.js', {
          method: 'POST', credentials: 'same-origin', keepalive: true, signal: controller.signal,
          headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attributes })
        });
        if (response.ok) lastMirror = key;
      } finally { clearTimeout(timer); }
    }).catch(function () {});
    return cartQueue;
  }
  async function identity(g) {
    if (!permitted(g) || !(await revokePending()) || !permitted(g)) return null;
    var value = read(identityKey);
    if (validIdentity(value)) return value;
    erase(identityKey); erase(sessionKey);
    var response = await request('identity', { consent: { analytics_allowed: true } }, false);
    if (!response.ok) return null;
    value = await response.json();
    if (!validIdentity(value)) return null;
    value = { visitor_id: value.visitor_id, visitor_token: value.visitor_token, expires_at: value.expires_at };
    if (!permitted(g)) { rememberRevocation(value); await revokePending(); return null; }
    write(identityKey, value, Math.min(maxAge, (expiry(value.expires_at) - Date.now()) / 1000));
    return validIdentity(read(identityKey)) ? value : null;
  }
  function safeURL(input) {
    if (!input) return '';
    try {
      var parsed = new URL(input, window.location.href);
      if (!/^https?:$/.test(parsed.protocol)) return '';
      var path = parsed.pathname;
      if (/\/(?:account|accounts|checkouts?|orders|authentication|reset|activate)(?:\/|$)/i.test(path)) path = '/';
      return parsed.origin + path.slice(0, 500);
    } catch (_) { return ''; }
  }
  function label(value) {
    return typeof value === 'string' && value.length <= 160 && !/[@\r\n<>]/.test(value) ? value : '';
  }
  function brand(value) {
    var name = String(value || '').toLowerCase().replace(/ö/g, 'o');
    return ['stikwood', 'slatwood', 'woodwol'].includes(name) ? name : '';
  }
  function itemBrand(item) {
    var vendor = String(item.vendor || '').toLowerCase().replace(/ö/g, 'o');
    var title = String(item.product_title || item.title || '').toLowerCase().replace(/ö/g, 'o');
    var sku = String(item.sku || '').toLowerCase();
    if (vendor.includes('slatwood')) return 'slatwood';
    if (vendor.includes('woodwol')) return 'woodwol';
    if (/slat ?wood/.test(title)) return 'slatwood';
    if (/woodwol|mosaic tile/.test(title)) return 'woodwol';
    if (sku.includes('slat')) return 'slatwood';
    if (sku.startsWith('ww') || sku.includes('woodwol')) return 'woodwol';
    return vendor === 'stikwood' ? 'stikwood' : '';
  }
  function fields(input) {
    input = input || {};
    var out = { page_url: safeURL(window.location.href), referrer: safeURL(document.referrer || ''), brand: brand(Object.prototype.hasOwnProperty.call(input, 'brand') ? input.brand : page.brand) };
    ['product_id', 'variant_id'].forEach(function (key) {
      var value = String(input[key] || page[key === 'product_id' ? 'productId' : 'variantId'] || '');
      if (/^[0-9]{1,20}$/.test(value)) out[key] = value;
    });
    var params = new URL(window.location.href).searchParams;
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (key) {
      var value = label(params.get(key)); if (value) out[key] = value;
    });
    var allowed = consent();
    if (allowed.marketing_allowed && allowed.sale_of_data_allowed) {
      ['gclid', 'gbraid', 'wbraid', 'msclkid'].forEach(function (key) {
        var value = label(params.get(key)); if (value) out[key] = value;
      });
      var fbclid = label(params.get('fbclid'));
      var fbc = fbclid ? 'fb.1.' + Date.now() + '.' + fbclid : label(cookie('_fbc'));
      var fbp = label(cookie('_fbp'));
      if (fbc) out.fbc = fbc;
      if (fbp) out.fbp = fbp;
    }
    return out;
  }
  function track(type, input) {
    if (!events.has(type) || !consent().analytics_allowed || pendingCount >= 40) return Promise.resolve(false);
    var g = generation;
    var body = Object.assign(fields(input), { event_id: uuid(), event_type: type, occurred_at: new Date().toISOString() });
    pendingCount++;
    var task = eventQueue.catch(function () {}).then(async function () {
      if (!permitted(g)) return false;
      var value = await identity(g);
      if (!value || !permitted(g)) return false;
      body.visitor_token = value.visitor_token;
      body.session_id = session();
      mirror(value, body.session_id, g);
      for (var attempt = 0; attempt < 2; attempt++) {
        if (!permitted(g) || !validIdentity(read(identityKey)) || read(identityKey).visitor_token !== value.visitor_token) return false;
        body.consent = consent();
        delete body.consent.analytics_known;
        if (!body.consent.marketing_allowed || !body.consent.sale_of_data_allowed) {
          ['gclid', 'gbraid', 'wbraid', 'fbc', 'fbp', 'msclkid'].forEach(function (key) { delete body[key]; });
        }
        try {
          var response = await request('collect', body, true);
          if (response.ok) return true;
          if (response.status === 401 || response.status === 403) {
            if ((read(identityKey) || {}).visitor_token === value.visitor_token) {
              erase(identityKey); erase(sessionKey); mirror(null, '', g);
            }
            return false;
          }
          if (response.status < 500 && response.status !== 429) return false;
        } catch (_) { if (!permitted(g)) return false; }
        if (attempt === 0) await new Promise(function (resolve) { setTimeout(resolve, 1000); });
      }
      return false;
    }).catch(function () { return false; }).finally(function () { pendingCount--; });
    eventQueue = task;
    return task;
  }
  function privacyChanged() {
    var state = consent();
    if (!state.analytics_known) return;
    var allowed = state.analytics_allowed;
    if (!allowed) {
      generation++;
      activeRequests.forEach(function (controller) { controller.abort(); });
      rememberRevocation(read(identityKey));
      erase(identityKey); erase(sessionKey);
      mirror(null, '', generation);
      // Other scripts/Shopify can retain an earlier fetch reference, outside
      // our observer. Bounded late clears settle concurrent consent writes.
      if (!denialSettling) [250, 1000].forEach(function (delay) {
        setTimeout(function () {
          var latest = consent();
          if (latest.analytics_known && !latest.analytics_allowed) {
            lastMirror = null;
            mirror(null, '', generation);
          }
        }, delay);
      });
      denialSettling = true;
      revokePending();
      booted = false;
    }
    lastAllowed = allowed;
    if (allowed) denialSettling = false;
    if (allowed && !booted) {
      booted = true;
      track('page_view');
      var type = { product: 'product_view', collection: 'collection_view', search: 'search', cart: 'cart_view' }[page.pageType];
      if (type) track(type);
    }
  }
  function loadPrivacy() {
    if (consent().analytics_known || privacyLoading || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    privacyLoading = true;
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        privacyLoading = false;
        if (!error) privacyChanged();
      });
    } catch (_) { privacyLoading = false; }
  }
  window.StikwoodJourney = { track: track, version: '1.0.2' };
  window.fetch = function (input, options) {
    var promise = originalFetch.apply(this, arguments);
    try {
      var url = new URL(typeof input === 'string' ? input : input.url, window.location.href);
      var method = (options && options.method) || (input && input.method) || 'GET';
      if (url.origin === window.location.origin && method.toUpperCase() === 'POST' &&
          /\/cart\/(add|change|update|clear)(?:\.js)?$/.test(url.pathname)) {
        var operation = url.pathname.match(/\/cart\/(add|change|update|clear)/)[1];
        // Shopify cart writes can race across independent scripts. Reconcile our
        // three attributes after every other successful write, including legacy
        // attribution-only updates. Our mirror uses originalFetch, so no loop.
        promise.then(function (response) {
          var state = consent();
          if (!response.ok || !state.analytics_known) return;
          lastMirror = null;
          var value = read(identityKey), session = read(sessionKey);
          mirror(state.analytics_allowed && validIdentity(value) ? value : null,
            session && session.id || '', generation);
        }).catch(function () {});
        var attributesOnly = false;
        try { var sent = JSON.parse(options.body); attributesOnly = !!sent.attributes && !sent.items && !sent.updates && !sent.id; } catch (_) {}
        if (!attributesOnly) {
          var g = generation;
          promise.then(function (response) {
            if (!response.ok || !permitted(g)) return;
            if (operation === 'add') {
              response.clone().json().then(function (data) {
                if (!permitted(g)) return;
                var items = Array.isArray(data.items) ? data.items.slice(0, 20) : [data];
                items.forEach(function (item) { track('add_to_cart', { product_id: item.product_id, variant_id: item.variant_id || item.id, brand: itemBrand(item) }); });
              }).catch(function () {});
            } else track('cart_updated');
          }).catch(function () {});
        }
      }
    } catch (_) {}
    return promise;
  };
  document.addEventListener('visitorConsentCollected', privacyChanged);
  window.addEventListener('online', function () { revokePending(); privacyChanged(); });
  window.addEventListener('pageshow', privacyChanged);
  document.addEventListener('click', function (event) {
    var el = event.target && event.target.closest ? event.target.closest('a,button,input') : null;
    if (!el) return;
    if (el.matches('[data-calc-apply]') && Number(el.dataset.calculatedQty) > 0) track('calculator_used');
    if (el.matches('[name="checkout"],a[href="/checkout"]')) { track('checkout_clicked'); }
    if (el.matches('a[href*="/products/"][href*="sample"]')) track('sample_cta_clicked');
  }, true);
  var videos = new WeakSet();
  document.addEventListener('timeupdate', function (event) {
    var video = event.target;
    if (video && video.tagName === 'VIDEO' && !video.autoplay && video.currentTime >= 10 && !videos.has(video) && consent().analytics_allowed) {
      videos.add(video); track('video_engaged');
    }
  }, true);
  privacyChanged();
  loadPrivacy();
  var checks = 0;
  var readiness = setInterval(function () {
    checks++;
    loadPrivacy();
    if (!booted || consent().analytics_allowed !== lastAllowed) privacyChanged();
    if (checks >= 20) clearInterval(readiness);
  }, 500);
})();
